import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { BLUE_500, BLUE_GREY_100, BLUE_GREY_300, WHITE, radioConfig, tokens } from '../../constants';
import { getCurrentEventControlState } from '../../utils';
export var getRadioTextProps = (event, props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  var _controlState = getCurrentEventControlState(event, props === null || props === void 0 ? void 0 : props.controlState);
  var labelFontType = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b[props === null || props === void 0 ? void 0 : props.size]) === null || _c === void 0 ? void 0 : _c.labelFontType;
  if (props === null || props === void 0 ? void 0 : props.isBoldLabel) labelFontType += '-bold';
  return {
    labelFontType,
    labelColor: (_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.config) === null || _d === void 0 ? void 0 : _d.controlState) === null || _e === void 0 ? void 0 : _e[_controlState]) === null || _f === void 0 ? void 0 : _f.labelColor,
    descriptionColor: (_j = (_h = (_g = props === null || props === void 0 ? void 0 : props.config) === null || _g === void 0 ? void 0 : _g.controlState) === null || _h === void 0 ? void 0 : _h[_controlState]) === null || _j === void 0 ? void 0 : _j.descriptionColor,
    descriptionFontType: (_m = (_l = (_k = props === null || props === void 0 ? void 0 : props.config) === null || _k === void 0 ? void 0 : _k.size) === null || _l === void 0 ? void 0 : _l[props === null || props === void 0 ? void 0 : props.size]) === null || _m === void 0 ? void 0 : _m.descriptionFontType
  };
};
var getRadioTextContainerStyle = props => {
  var _a;
  var spacing = (_a = tokens.spacing) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.spacing];
  var labelPosition = props.labelPosition,
    label = props.label,
    description = props.description,
    radioDisplay = props.radioDisplay;
  var hasLabelOrDesc = label || description;
  return Object.assign(Object.assign({}, radioDisplay === 'block' && {
    flex: 1
  }), hasLabelOrDesc && Object.assign({}, labelPosition == 'right' ? {
    marginLeft: spacing
  } : {
    marginRight: spacing
  }));
};
export var getRadioCircleStyle = (props, controlState) => {
  var _a, _b, _c, _d, _e;
  var configProps = props === null || props === void 0 ? void 0 : props.config;
  var radioSize = (_a = configProps === null || configProps === void 0 ? void 0 : configProps.size) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.size].radioSize;
  var borderColor = (_c = (_b = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _b === void 0 ? void 0 : _b[controlState]) === null || _c === void 0 ? void 0 : _c.borderColor;
  var disabledBorderColor = (_e = (_d = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _d === void 0 ? void 0 : _d.disabled) === null || _e === void 0 ? void 0 : _e.borderColor;
  return Object.assign({
    height: radioSize,
    width: radioSize,
    backgroundColor: WHITE,
    borderRadius: 3.5 * radioSize,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: tokens.spacing.SPACING_2
  }, props.disabled ? {
    borderColor: disabledBorderColor
  } : {
    borderColor: borderColor
  });
};
export var getRadioSelectedStyle = (props, controlState) => {
  var _a, _b, _c, _d, _e;
  var configProps = props === null || props === void 0 ? void 0 : props.config;
  var radioSize = (_a = configProps === null || configProps === void 0 ? void 0 : configProps.size) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.size].radioSize;
  var color = (_c = (_b = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _b === void 0 ? void 0 : _b[controlState]) === null || _c === void 0 ? void 0 : _c.color;
  var disabledColor = (_e = (_d = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _d === void 0 ? void 0 : _d.disabled) === null || _e === void 0 ? void 0 : _e.color;
  return Object.assign({
    width: radioSize / 2,
    height: radioSize / 2,
    borderRadius: 2 * radioSize
  }, props.disabled ? {
    backgroundColor: disabledColor
  } : {
    backgroundColor: color
  });
};
var getContainerBasicStyle = props => {
  return Object.assign(Object.assign(Object.assign({}, props.labelPosition == 'right' && {
    flexDirection: 'row'
  }), props.labelPosition == 'left' && {
    flexDirection: 'row-reverse'
  }), props.showAsCard && {
    padding: tokens.spacing.SPACING_12
  });
};
export var getRadioStyles = (props, event) => {
  var controlState = props.controlState;
  var _controlState = getCurrentEventControlState(event, controlState);
  return StyleSheet.create({
    container: getContainerBasicStyle(props),
    radioCircle: getRadioCircleStyle(props, _controlState),
    radioSelected: getRadioSelectedStyle(props, _controlState),
    radioTextContainer: getRadioTextContainerStyle(props),
    radioText: {
      marginTop: tokens.spacing.SPACING_4
    }
  });
};
export var getRadioWrapperStyles = props => {
  var checked = props.checked,
    showInfoTagOnCard = props.showInfoTagOnCard;
  return StyleSheet.create({
    containerStyles: {
      flex: 1
    },
    selectedBorderColor: Object.assign({}, checked && {
      borderColor: BLUE_500
    }),
    cardStyles: Object.assign(Object.assign({}, showInfoTagOnCard && {
      borderTopLeftRadius: 0
    }), {
      borderColor: BLUE_GREY_300,
      backgroundColor: BLUE_GREY_100
    })
  });
};
export var getRadioProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(radioConfig === null || radioConfig === void 0 ? void 0 : radioConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.radio) === null || _a === void 0 ? void 0 : _a[theme]);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    controlState
  });
};